import React, { useState, useEffect } from 'react';
import { HelpCircle, MessageCircleQuestion } from 'lucide-react';

const ConsultationCTA = ({
  title = "Unsure About the Right Choice?",
  description = "Get a Free Personalized Consultation",
  buttonText = "Free Consultation",
  message = "Hi! I'm interested in a free massage consultation. Can you help me choose the right service?"
}) => {
  const [editableMessage, setEditableMessage] = useState(message);

  // Keep the draft in sync if a different page renders this with a different default message.
  useEffect(() => {
    setEditableMessage(message);
  }, [message]);

  const onConsultClick = () => {
    const phoneNumber = process.env.REACT_APP_WHATSAPP_NO;
    const formattedNumber = phoneNumber.replace(/\D/g, '');
    const whatsappUrl = `https://wa.me/${formattedNumber}?text=${encodeURIComponent(editableMessage)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="bg-accent-lighter border border-accent-hard/20 rounded-xl p-4 sm:p-6 md:p-8 shadow-md my-6 sm:my-8">
      <div className="flex items-start sm:items-center gap-3 sm:gap-4 mb-4">
        <div className="hidden sm:flex items-center justify-center w-12 h-12 rounded-full bg-primary-dark shrink-0">
          <MessageCircleQuestion className="text-accent-light" size={24} strokeWidth={1.5} />
        </div>
        <div>
          <h3 className="text-base sm:text-lg md:text-xl font-semibold text-primary-dark mb-1">
            {title}
          </h3>
          <p className="text-dim-light text-xs sm:text-sm md:text-base">
            {description}
          </p>
        </div>
      </div>

      <label className="block text-xs font-medium text-dim-light mb-1">
        Your message to us (edit it if you'd like)
      </label>
      <textarea
        value={editableMessage}
        onChange={(e) => setEditableMessage(e.target.value)}
        rows={3}
        className="w-full p-3 rounded-lg border border-accent-hard/30 bg-white text-sm text-dim mb-3 focus:outline-none focus:ring-2 focus:ring-accent-hard resize-none"
      />

      <button
        onClick={onConsultClick}
        className="w-full sm:w-auto bg-primary-dark text-secondary px-4 py-2 rounded-lg hover:bg-accent-hard hover:text-primary-dark transition-colors flex items-center justify-center gap-2 text-sm sm:text-base font-semibold"
      >
        <HelpCircle size={18} />
        {buttonText}
      </button>
    </div>
  );
};

export default ConsultationCTA;
